import { has, reset, get, addToHistory, getHistory } from "./storage";

export default function Hero({ onExpense, onHistory }) {
  const hasSavedExpense = has();
  const historyCount = getHistory().length;

  const handleNewExpense = () => {
    if (hasSavedExpense) {
      const current = get();
      if (current) {
        addToHistory(current);
      }
      reset();
    }
    onExpense();
  };

  return (
    <div className="hero">
      <span className="hero-leaf" role="img" aria-label="hoja">
        🍃
      </span>
      <h1 className="hero-title">Salidas</h1>
      <p className="hero-subtitle">
        ¿Saliste y pagaste tu la cuenta? No te preocupes, divide la cuenta de
        manera fácil.
      </p>
      <div className="hero-actions">
        {hasSavedExpense ? (
          <>
            <button className="btn btn-primary" onClick={onExpense}>
              ✏️ Continuar Gasto
            </button>
            <button className="btn btn-secondary" onClick={handleNewExpense}>
              🌱 Nueva Salida
            </button>
          </>
        ) : (
          <button className="btn btn-primary" onClick={onExpense}>
            🍔 Nuevo Gasto
          </button>
        )}
      </div>
      {historyCount > 0 && (
        <button className="btn-history" onClick={onHistory}>
          📋 Historial
          <span className="history-badge">{historyCount}</span>
        </button>
      )}
    </div>
  );
}
